const ArgumentType = require('../extension-support/argument-type');
const BlockType = require('../extension-support/block-type');
const Cast = require('../util/cast');

class Scratch3Performance {
    constructor(runtime) { this.runtime = runtime; this._marks = {}; }
    getInfo() {
        return {
            id: 'perfExt', name: '⚡ パフォーマンス', color1: '#E91E63', color2: '#C2185B',
            blocks: [
                { opcode: 'mark', blockType: BlockType.COMMAND, text: 'マーク [N] を記録', arguments: { N: { type: ArgumentType.STRING, defaultValue: 'start' } } },
                { opcode: 'measure', blockType: BlockType.REPORTER, text: '[A] から [B] の時間(ms)', arguments: { A: { type: ArgumentType.STRING, defaultValue: 'start' }, B: { type: ArgumentType.STRING, defaultValue: 'end' } } },
                { opcode: 'now', blockType: BlockType.REPORTER, text: '高精度タイムスタンプ' },
                { opcode: 'memory', blockType: BlockType.REPORTER, text: '使用メモリ(MB)' }
            ]
        };
    }
    mark(args) { this._marks[args.N] = performance.now(); }
    measure(args) { var a = this._marks[args.A] || 0, b = this._marks[args.B] || 0; return Math.abs(b - a); }
    now() { return performance.now(); }
    memory() { return performance.memory ? Math.round(performance.memory.usedJSHeapSize / 1048576) : 0; }
}
module.exports = Scratch3Performance;